import { Stack } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useNavigate, useLocation } from 'react-router-dom'
import LoginPaper from '../Login/components/LoginPaper'
import LoginButton from '../Login/components/LoginButton'
import AuthBasePageWrapper from '../Login/AuthBasePageWrapper'
import {
  ContentContainer,
  PageTitle,
  ButtonContainer,
  ErrorIconContainer,
  ErrorMessage
} from './styles'

const SponsorCodeErrorPanel = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const location = useLocation()
  const errorPath = location.pathname.split('/errors/')[1]
  const errorCode = errorPath || 'sponsor.error.unknown'
  
  const getTitleKey = () => {
    if (errorCode === 'sponsor.error.invalid_link') {
      return 'sponsor.error.title_invalid_link'
    } else if (errorCode === 'sponsor.error.expired') {
      return 'sponsor.error.title_expired'
    } else {
      return 'sponsor.error.title_generic'
    }
  }
  
  const handleBackToLogin = () => {
    navigate('/auth/login')
  }
  
  return (
    <LoginPaper sx={{ display: 'flex', justifyContent: 'center' }}>
      <ContentContainer>
        <PageTitle sx={{ textAlign: 'center' }}>
          {t(getTitleKey())}
        </PageTitle>
        
        <Stack alignItems="center" spacing={2} width="100%">
          <ErrorIconContainer>
            <i className="fa-light fa-triangle-exclamation"></i>
          </ErrorIconContainer>
          <ErrorMessage>
            {t(errorCode)}
          </ErrorMessage>
        </Stack>
        
        <ButtonContainer>
          <LoginButton
            onClick={handleBackToLogin}
            sx={{ width: '100%' }}
          >
            {t('sponsor.error.back_to_login')}
          </LoginButton>
        </ButtonContainer>
      </ContentContainer>
    </LoginPaper>
  )
}

const SponsorCodeErrorPage = () => (
  <AuthBasePageWrapper>
    <SponsorCodeErrorPanel />
  </AuthBasePageWrapper>
)

export default SponsorCodeErrorPage

